import { isEmptyObject } from '~/core/util/object';
import { analyticsTrackEvent } from '~/core/analytics';
import { PROFILE_DISCOVER_CARD_TAPPED } from '~/core/analytics/events';
import {
  CategoryIds,
  TileIds,
} from '~/components/AccountGetsMarried/components/SwimLanes/util/tileEnums';

export const ProfileDiscoverTracking = (drawerType: string, location: any) => {
  if (!isEmptyObject(location)) {
    analyticsTrackEvent(PROFILE_DISCOVER_CARD_TAPPED, {
      categoryId: CategoryIds.FAVORITES,
      titleId: TileIds.FAVORITE_CLINIC,
      drawerType,
    });
  } else {
    analyticsTrackEvent(PROFILE_DISCOVER_CARD_TAPPED, {
      categoryId: CategoryIds.GET_STARTED,
      drawerType,
    });
  }
};
